import '../../UI/Common/EmojiBox.css';
import React from 'react';

interface Props {
    selected: boolean;
    emoji?: any;
    onEmojiClick: any;
}

const EmojiBox: React.FC<Props> = ({ emoji, selected, onEmojiClick }) => {
    const handleClick = () => {
        if (emoji.id === "13") {
            onEmojiClick(true);
        } else {
            onEmojiClick(emoji.id);
        }

    }

    return (
        <div className={'emoji-box-container'} onClick={handleClick}>
            <div className={selected ? 'emoji-div-selected' : 'emoji-div'}>
                <img className='emoji-box-image' src={emoji.src} alt={emoji.title} />
            </div>
            <p className={selected ? 'emoji-title-selected-p' : 'emoji-title-p'}>{emoji.title}</p>
        </div>
    )
}

export default EmojiBox;